// Utility functions for tenant management
export const getCurrentTenantId = () => {
  // Try to get from saasData.currentTenant first
  try {
    const saasData = JSON.parse(localStorage.getItem('saasData') || '{}');
    if (saasData?.currentTenant?.id) {
      console.log('Using tenant ID from saasData:', saasData.currentTenant.id);
      return saasData.currentTenant.id;
    }
  } catch (e) {
    console.error('Error parsing saasData:', e);
  }
  
  // Fallback to hardcoded tenant ID for MyClass Real School A
  console.log('Using hardcoded tenant ID as fallback');
  return 'eadcd263-a399-4261-8cbd-8fb1ce6da0e3';
};

export const getTenantName = (tenantId) => {
  const tenantNames = {
    'eadcd263-a399-4261-8cbd-8fb1ce6da0e3': 'MyClass Real School A',
    '1acd60af-8884-48bb-b1ea-13fbb935d3a8': 'MyClass Real School B',
    'adf83c8b-b623-4f69-b65f-25e11c2781ce': 'MyClass Real School C'
  };
  return tenantNames[tenantId] || 'Unknown School';
};
